export { AssetsModule } from './src/app/assets.module';



// WEBPACK FOOTER //
// ./~/@c4/assets/index.ts